async function addCss(working, command, p) {
  let css = command.getArg("css");
  const url = command.getArg("url");
  if (url) {
    const res = await fetch(url);
    if (!res.ok) {
      throw new Error(
        `Failed to fetch CSS from ${url}: ${res.status} ${res.statusText}`
      );
    }
    css = await res.text();
  }
  if (!css) {
    throw new Error("No CSS provided.");
  }
  return working.text + "\n" + `<style>${css}</style>`;
}
addCss.key = "add-css";
addCss.title = "Add CSS";
addCss.category = "CSS / Styling";
addCss.docUrl = "https://deanebarker.net/tech/code/textflow-js/commands/add-css/";
addCss.description = "Add a block of CSS to the embedded content.";
addCss.args = [
  { name: "css", type: "string", description: "The CSS to add." },
  { name: "url", type: "string", description: "A URL to fetch CSS from." },
];
addCss.parseValidators = [
  {
    test: (command) => {
      return command.hasArg("css") || command.hasArg("url");
    },
    message:
      "You must provide a 'css' argument or a 'url' argument with a URL to a CSS file.",
  },
];

export default addCss;
